import { render, staticRenderFns } from "./code-input.vue?vue&type=template&id=6a32a7a5&scoped=true&"
import script from "./code-input.vue?vue&type=script&lang=js&"
export * from "./code-input.vue?vue&type=script&lang=js&"
import style0 from "./code-input.vue?vue&type=style&index=0&id=6a32a7a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a32a7a5",
  null
  
)

export default component.exports